"use strict"

/**
 * AnyStore keeps a single global instance of the active store.
 */
class AnyStore {
    static get inst() {
        if(!this._inst) {
            if(!this.instClass) {
                throw new Error("No store service loaded!")
            }
            this._inst = new this.instClass()
        }
        return this._inst
    }
    /**
     * @param {typeof StackStore} c
     */
    static register(c) {
        this.instClass = c
    }
}

class StackStore extends NetworkPropertySet {
    constructor() {
        super();
        this.DEBUG = false;

        this.allPackageAllowanceProductInfo = null;
        this.brandLogoDataUrl               = null;
        this.catalogueConfig                = null;
        this.countryToTelephoneCode         = null;
        this.paymentConfig                  = null;
        this.paymentItems                   = null;
        this.productByType                  = null;
        this.productCustomCategory          = null;
        this.shopPageData                   = null;
        this.timeDatePreferences            = null;
    }

    // =========================
    // Network property handlers
    // =========================

    /**
     * Return handlers for properties. Each should return the value (which
     * NetworkPropertySet will assign to this[prop]), and we also write it
     * to localStorage via cacheItem (default 5 min TTL).
     */
    get networkPropertyHandlers() {
        return {
            allPackageAllowanceProductInfo: async () => {
                try {
                    return await $.ajax(`/n/catalogue/product/packageAllowanceProvisioningInfo`);
                } catch(e) {
                    if(this.DEBUG) console.error(e);
                    return null;
                }
            },
            brandLogoDataUrl: async () => {
                const url = "/brandLogo?" + Math.random();
                try {
                    await $.ajax({ method: "HEAD", url });
                    return url;
                } catch(e) {
                    if(this.DEBUG) console.error(e);
                    return null;
                }
            },
            catalogueConfig: async () => {
                try {
                    return await $.ajax(`/a/catalogue/config`);
                } catch(e) {
                    if(this.DEBUG) console.error(e);
                    return {};
                }
            },
            countryToTelephoneCode: async () => {
                try {
                    return await $.ajax("/app/json/countryToTelephoneCode.json");
                } catch(e) {
                    if(this.DEBUG) console.error(e);
                    return null;
                }
            },
            paymentConfig: async () => {
                if (!window.isLoggedIn) return null;
                try {
                    return await $.ajax(`/n/payment/config`);
                } catch(e) {
                    if(this.DEBUG) console.error(e);
                    return null;
                }
            },
            paymentItems: async () => {
                try {
                    await SUser.inst.preloadSingle("identityInfo");

                    return await $.ajax({
                        method: "get",
                        url: `/n/payment/paymentItem`,
                        data: {
                            selector: {
                                owner: `${SUser.inst.identityInfo.content}`,
                            },
                            fields: [
                                "display",
                                "owner",
                                "type",
                                "id",
                                "isBillable",
                                "availableNonPayable",
                                "availablePayable",
                                "availableBalance"
                            ]
                        }
                    })
                } catch(e) {
                    if(this.DEBUG) console.error(e);
                    return null;
                }
            },
            productByType: async () => {
                try {
                    await this.preloadSingle("shopPageData");
                    return this.shopPageData.productByType;
                } catch(e) {
                    if(this.DEBUG) console.error(e);
                    return null;
                }
            },
            productCustomCategory: async () => {
                try {
                    await this.preloadSingle("shopPageData");
                    return this.shopPageData.productCustomCategory;
                } catch(e) {
                    if(this.DEBUG) console.error(e);
                    return null;
                }
            },
            shopPageData: async () => {
                try {
                    return await $.ajax(`/a/catalogue/shopPageData`);
                } catch(e) {
                    if(this.DEBUG) console.error(e);
                    return null;
                }
            },
            timeDatePreferences: async () => {
                if (!window.isLoggedIn) return null;
                try {
                    const val = await $.ajax(`/a/timeDatePreferences`);
                    return (val && val.length > 0 ? val[0] : null);
                } catch(e) {
                    if(this.DEBUG) console.error(e);
                    return null;
                }
            },
        }
    }
}

AnyStore.register(StackStore);
